const apiUrls = require('constants/apiUrls');
import * as Rx from 'rxjs';
const {Observable} = Rx;
const {ajax} = Observable;
import {LOGGING_ENABLED, MIN_LOG_LEVEL, IMMEDIATE_SEND_MIN_LEVEL, LOGGING_SEND_INTERVAL, LOGGING_INCLUDED_ACTIONS} from 'constants/actionLoggingConfig';
import {getAccessTokenFromState} from 'utils/userManager';

let currentLogs = [];
let reduxStore = null;

export const setStore = (store) => {
    reduxStore = store;
};

const sendLogs = () => {
    if (currentLogs.length === 0 || !reduxStore) {
        return;
    }

    const accessToken = getAccessTokenFromState(reduxStore.getState());
    if (!accessToken) {
        return;
    }

    const userId = reduxStore.getState().getIn(['user', 'userId']);

    ajax({
        url: apiUrls.TECH_SEND_TRANSACTION_LOGS_URL,
        method: 'POST',
        body: {
            billingSystem: 'n/a',
            userId: userId,
            lg: currentLogs,
            accountNumber: 'n/a',
            workOrderNumber: 'n/a',
            transactionType: 'log_dump'
        },
        responseType: '',
        crossDomain: true,
        timeout: apiUrls.API_TIMEOUT,
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'authorization': 'Bearer ' + accessToken
        }
    })
    .subscribe(function (data) {
        if (data.status === 200) {
            currentLogs = [];
        }
    }, function (error) {
        console.error(error);
    });

};

if (LOGGING_ENABLED === true) {
    setInterval(() => {
        sendLogs();
    }, LOGGING_SEND_INTERVAL);
} else {
    console.warn(`Logging Disabled - logs will not be sent`);
}

const payloadIsLoggable = (payload) => {
    if (payload.type) {
        if (LOGGING_INCLUDED_ACTIONS.indexOf(payload.type) > -1) {
            return true;
        } else {
            return false;
        }
    } else if (payload.category) {
        return true;
    } else {
        return true;
    }
};

const log = (level, payload, logger) => {

    const log = {
        logName: logger,
        payload: JSON.stringify(payload),
        level: level,
        clientTimeStamp: Date.now()
    };

    if (LOGGING_ENABLED === true && level >= MIN_LOG_LEVEL && payloadIsLoggable(payload)) {
        currentLogs.push(log);
        if (level >= IMMEDIATE_SEND_MIN_LEVEL) {
            sendLogs();
        }
    }

};

export default(logger) => {
    return {
        trace: (payload) => {
            log(1000, payload, logger);
        },
        debug: (payload) => {
            log(2000, payload, logger);
        },
        info: (payload) => {
            log(3000, payload, logger);
        },
        warn: (payload) => {
            log(4000, payload, logger);
        },
        error: (payload) => {
            log(5000, payload, logger);
        },
        fatal: (payload) => {
            log(6000, payload, logger);
        }
    };
};


// WEBPACK FOOTER //
// ./src/utils/logger.js